import type { NavbarContentConfig } from './types'
import { communitySupport } from './navbar-items/community-support'
import { documentation } from './navbar-items/documentation'
import { resources } from './navbar-items/resources'
import { topicGuides } from './navbar-items/topic-guides'
import { whyPennyLane } from './navbar-items/why-pennylane'

export default {
  navbarLeft: [
    whyPennyLane,
    documentation,
    resources,
    topicGuides,
    communitySupport,
    // Uncomment to test a link without subLinks
    // {
    //   name: 'Test',
    //   href: '/test',
    //   pill: {
    //     text: 'New',
    //     variant: 'info',
    //     startDate: '2026-05-01',
    //     expiryDate: '2026-07-01',
    //   },
    // },
  ],
  navbarRight: {
    buttonLink: {
      text: 'Install',
      link: '/install',
    },
  },
  signInCard: {
    description:
      'Welcome to PennyLane! To make the most of your experience, sign in or create a free account with us.',
    buttonText: 'Sign in',
    createAccountText: 'Create a free account',
    bottomLinks: [
      { link: '/terms', text: 'Terms of service' },
      { link: '/privacy', text: 'Privacy policy' },
    ],
  },
  mobileButton: {
    text: 'Install',
    link: '/install',
  },
} satisfies NavbarContentConfig
